import { get_token, get_user_details } from "@/router";
import Swal from 'sweetalert2';
import { client_domain } from "@/main.js";
/* global bootstrap */

export default {
  data() {
    return ({
      groups: [],
      group_name: '',
      group_description: '',
      is_public: true,
      isLoading: false,
      token_exists: false,
      errors: {},
      portal_id: "",
      editing: false,
      editing_group_id: null,
      school_domain: false,
      user_details: get_user_details(),
      visibleGroupsCount: 3,
      show_all_desktop_groups: false,
    });
  },
  computed: {
    isHomePage() {
      return this.$route.name === 'home'; // Assuming your home page route is named 'home'
    },

    filtered_groups() {
      if (this.isHomePage) {
        return this.groups.slice(0, this.visibleGroupsCount);
      }
      return this.groups;
    },
    visible_desktop_groups() {
      if (this.show_all_desktop_groups) {
        return this.groups;
      }

      return this.groups.slice(0, 4);
    },
    has_more_desktop_groups() {
      return this.groups.length > 4;
    },
  },
  mounted() {
    if (client_domain.includes('chiefluthuli')) {
      this.school_domain = true
    }
  
    this.fetch_groups();
    this.token_exists = get_token();
    this.user_id = this.get_user_id();
  },

  watch: {
    '$route.params.portal_id'() {
      this.fetch_groups();
    }
  },

    methods:{
    getToken() {
      return get_token();
    },
    fetch_groups() {
      this.isLoading = true;
      let data = {};
      if (this.$route.params.portal_id) {
        data.portal_id = this.$route.params.portal_id;
      }
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/group_management/portal_group/`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: data,
        success: (data) => {

          this.groups = data.groups.sort((a, b) => b.id - a.id);
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    handleSubmit() {
      if (!this.editing) {
        this.create_group();
        this.editing = false;
        return;
      }
      this.updateGroup();
    },
    create_group() {
      if (!this.handle_unauthenticated() || !this.validationGroupForm()) {
        return;
      }
      this.isSubmitting = true;
      const payload = {
        name: this.group_name,
        is_public: this.is_public,
        portal_id: this.$route.params.portal_id,
      };
      if (this.$route.params.portal_id) {
        payload.portal_id = this.$route.params.portal_id;
      }
      if (this.group_description.trim()) {
        payload.description = this.group_description;
      }

      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/group_management/create_group/`,
        contentType: "application/json",
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(payload),
        success: (response) => {
          const status = response.status;
          if (status === "success") {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: "Created Successfully",
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              this.fetch_groups()
              this.reset_form()
              $("#create_group_modal").modal("hide");
            });
          }
        },
        error: (response) => {
          const response_data = response.responseJSON;
          if (response_data.status === "error") {
            this.errors.group_name = response_data.message;
          }
        },
        complete: () => {
          this.isSubmitting = false;
        },
      });
    },
    updateGroup() {
      if (!this.handle_unauthenticated() || !this.validationGroupForm()) {
        return;
      }
      const payload = {
        name: this.group_name,
        group_id: this.editing_group_id,
        description: this.group_description,
        is_public: this.is_public,
      };
      if (this.group_description.trim()) {
        payload.description = this.group_description;
      }

      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/group_management/update_group/`,
        contentType: "application/json",
        headers: {
          Authorization: `Token ${this.getToken()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify(payload),
        success: (response) => {
          const status = response.status;
          if (status === "success") {
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Group Updated Successfully',
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              this.fetch_groups()
              this.reset_form()
              $("#create_group_modal").modal("hide");
              this.editing = false;
            });
          }
        },
        error: (response) => {
          const response_data = response.responseJSON;
          if (response_data.status === "error") {
            this.errors.group_name = response_data.message
          }
        },
        complete: () => {
          this.isSubmitting = false;
        },
      });
    },
    deleteGroup(group_id) {
      Swal.fire({
        title: "Are you sure?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: "DELETE",
            url: `${process.env.VUE_APP_BACKEND_API_URL}/group_management/delete_group/`,
            data: { group_id: group_id },
            headers: {
              Authorization: `Token ${this.getToken()}`,
            },
            success: (response) => {
              const status = response.status;
              if (status === "success") {
                this.groups = this.groups.filter(
                  (group) => group.id !== group_id
                );
                const currentGroupIdInRoute = this.$route.params.group_id;

                if (String(currentGroupIdInRoute) === String(group_id)) {
                  // Redirect to the previous page
                  this.$router.go(-1);
                }
              }
            },
            error: () => {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to delete the feed. Please try again.",
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              });
            },
          });
        }
      });
    },
    validationGroupForm() {
      this.errors = {};
      let valid = true;

      if (!this.group_name) {
        this.errors.group_name = "Group name is required";
        valid = false;
      }
      if (this.is_public == null) {
        this.errors.group_name = "Visibility is required";
        valid = false;
      }
      return valid;
    },
    openEditGroupModal(group) {
      const offcanvasEl = document.getElementById('groups')
      const offcanvas = bootstrap.Offcanvas.getInstance(offcanvasEl)

      if (offcanvas) {
        offcanvas.hide()
      }
      this.editing = true;
      this.group_name = group.name;
      this.group_description = group.description || '';
      this.is_public = group.is_public;
      this.editing_group_id = group.id;
    },

    handle_unauthenticated() {
      if (!this.token_exists) {
        this.$router.push({ name: 'sign_in_finale' });
        return false;
      }
      return true;
    },
    baseUrl(post, type) {
      const baseUrl = `${window.location.origin}${this.$route.path}`;
      if (type === 'voice') {
        return `${baseUrl}?voice_id=${post.id}`;
      } else if (type === 'feed') {
        return `${baseUrl}?feed_id=${post.id}`;
      }
      return baseUrl
    },
    getIdFromURL(param) {
      const urlParams = new URLSearchParams(window.location.search);

      return urlParams.get(param);
    },
    open_group(group) {
      if (!this.handle_unauthenticated()) {
        return;
      }

      const portalId = group.portal_id || this.$route.params.portal_id || 0;

      // If the user has access
      if (group.has_access === "approved") {
        this.close_groups_offcanvas();

        this.$router.push({
          name: "view_group",
          params: {
            portal_id: portalId, group_id: group.id, group_name: group.name, is_public: group.is_public
          },
        });
      }
      
      else {
        Swal.fire({
          icon: 'error',
          title: 'Access Denied',
          text: 'You do not have access to this group.',
          showConfirmButton: true
        });
      }
    },
    toggle_desktop_groups() {
      this.show_all_desktop_groups = !this.show_all_desktop_groups;
    },
    close_groups_offcanvas() {
      const offcanvasEl = document.getElementById('groups');
      const offcanvas = bootstrap.Offcanvas.getInstance(offcanvasEl);

      if (offcanvas) {
        offcanvas.hide();
      }
    },

    display_comment_modal(feed_data) {
      if (!this.handle_unauthenticated()) {
        return;
      }

      this.feed_data = feed_data;
      this.comment_modal_visible = true;
    },
    addNewGroupFeed(newFeed) {
      if (newFeed) {
        this.group_feeds.unshift(newFeed
        );
      }
    },
    getGroupFeedLikes(group_feed) {
      if (!group_feed || !group_feed.id) {
        return;
      }
      $.ajax({
        type: "GET",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/group_management/retrieve_group_feed_likes/`,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        data: { group_feed_id: group_feed.id },
        success: (response) => {
          if (response.status === "success") {
            const likes = response.data;
            group_feed.like_count = likes.length;

            const userId = this.get_user_id();
            const isLiked = likes.some(
              (like) => like.user.id === parseInt(userId, 10)
            );

            const likeButton = document.getElementById(`like-button${group_feed.id}`);
            const likedButton = document.getElementById(`liked-button${group_feed.id}`);

            if (likeButton) {
              likeButton.classList.toggle('d-none', isLiked);
            }

            if (likedButton) {
              likedButton.classList.toggle("d-none", !isLiked);
            }
          }
        },
      });
    },
    get_user_id() {
      const user_id = localStorage.getItem("user_id") || "";
      return user_id;
    },

    reset_form() {
      this.group_name = ''
      this.group_description = ''
      this.is_public = true

      this.errors = {}

      this.editing = false
      this.editing_group_id = null
    },
    openCreateGroupModal() {
    const offcanvasEl = document.getElementById('groups')
    const offcanvas = bootstrap.Offcanvas.getInstance(offcanvasEl)

    if (offcanvas) {
      offcanvas.hide()
    }

    $('#create_group_modal').modal('show');
  },

  },
};
